import modelFactory from './apiFactory';

const model = new modelFactory({ name: 'users', overrides: [] });

console.log('userAPI Model: ', model);

export default model;
